export const apiUrl = "https://organic-api.rcs-mm.com/api/v1/";
